import React, { useEffect, useState } from "react";
import Sidebar from "../../../Items/Sidebar";
import { Link } from "react-router-dom";
import useVerify from "../../../useVerify";

export default function Index() {
  useVerify("admin");

  const [quizs, setQuizs] = useState([]);

  useEffect(() => {
    // Fetch data from API
    fetch(`${process.env.REACT_APP_BASE_URL}/api/quizs`)
      .then((response) => response.json())
      .then((data) => {
        setQuizs(data);
      });

    // eslint-disable-next-line
  }, []);

  return (
    <div className="w-full flex flex-row">
      <div className="w-1/5">
        <Sidebar/>
      </div>
      <div className="w-max md:w-4/5 bg-slate-100 p-20 h-screen overflow-auto">
        <h1 className="text-5xl font-extrabold text-[#FF914D]">Daftar Tes</h1>
        <div className="mt-12">
          <div className="grid grid-cols-3 gap-4">
            {quizs.map((quiz) => (
              <div key={quiz.quizId}>
                <Link
                  to={`/detailquiz/${quiz.quizId}`}
                  className="flex flex-col justify-center items-center h-24 rounded-md shadow-xl bg-slate-600
                      hover:bg-slate-800  group transition duration-500 ease-in-out"
                >
                  <h3 className="text-2xl group-hover:text-orange-500  text-center text-white font-bold tracking-wide transition duration-500 ease-in-out">
                    {quiz.quizName}
                  </h3>
                  <h4 className="text-xl text-white group-hover:text-orange-500 transition duration-500 ease-in-out">
                    {quiz.jumlahKoloms} Kolom
                  </h4>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
